import { useEffect, useRef } from "react";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { appStore } from "entities/App/model/app.store";
import { isRailSearchShipmentModel } from "entities/RailSearchCard";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";

import { getInitialSearchQPM } from "../ParamsManager";

type UseRailUrlQueryHandlerProps = {
  openedCard: ShipmentModel | null;
};

export const useRailUrlQueryHandler = ({ openedCard }: UseRailUrlQueryHandlerProps) => {
  const dispatch = useAppDispatch();
  const openedCardQPM = useRef(getInitialSearchQPM()).current;
  const requestedFromUrl = useAppSelector(appStore.selectors.requestedFromUrl);
  const { isCurrentViewOpenedCard } = usePanelViews();

  useEffect(() => {
    if (!isCurrentViewOpenedCard) return;
    if (requestedFromUrl || !openedCard?.reference) return;

    openedCardQPM.set("number", openedCard.reference);

    if (isRailSearchShipmentModel(openedCard)) {
      const carrierCode = openedCard?.carrierCode;
      if (carrierCode) {
        openedCardQPM.set("carrierCode", carrierCode);
      }
    }

    openedCardQPM.update();
  }, [openedCard?.rawData]);

  useEffect(
    () => () => {
      openedCardQPM.clear();
      openedCardQPM.update();
      dispatch(appStore.actions.setRequestedFromUrl(false));
    },
    []
  );
};
